function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 12C0 5.3772 5.376 0 12 0C18.636 0 24 5.3772 24 12C24 18.6252 18.636 24 12 24C5.376 24 0 18.6252 0 12ZM11.4304 14.9901L16.1804 10.2401C16.5204 9.90012 16.5204 9.35012 16.1804 9.00012C15.8404 8.66012 15.2804 8.66012 14.9404 9.00012L10.8104 13.1301L9.06043 11.3801C8.72043 11.0401 8.16043 11.0401 7.82043 11.3801C7.48043 11.7201 7.48043 12.2701 7.82043 12.6201L10.2004 14.9901C10.3704 15.1601 10.5904 15.2401 10.8104 15.2401C11.0404 15.2401 11.2604 15.1601 11.4304 14.9901Z",
  fill: "#24C277"
});

var SvgAlertSuccessIcon = function SvgAlertSuccessIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlertSuccessIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AlertSuccessIcon.b511c4d2.svg";
export { ForwardRef as ReactComponent };